export enum TRACKING_EVENT_NAMES {
  jswInteractiveBoardIssueModalOpened = 'jswInteractiveBoardIssueModalOpened',
  jswInteractiveBoardSelectIssueType = 'jswInteractiveBoardSelectIssueType',
  jswInteractiveBoardAddSummary = 'jswInteractiveBoardAddSummary',
  jswInteractiveBoardAddDescription = 'jswInteractiveBoardAddDescription',
  jswInteractiveBoardSelectPriority = 'jswInteractiveBoardSelectPriority',
  jswInteractiveBoardSelectEpicLink = 'jswInteractiveBoardSelectEpicLink',
  jswInteractiveBoardCreateIssue = 'jswInteractiveBoardCreateIssue',
  jswInteractiveBoardSuccessModalClosed = 'jswInteractiveBoardSuccessModalClosed',
  jswInteractiveBoardSuccessModalGetStarted = 'jswInteractiveBoardSuccessModalGetStarted',
  jswInteractiveBoardCreateModalClosed = 'jswInteractiveBoardCreateModalClosed'
}
